import React from "react";
import FieldRenderer from "./FieldRenderer";
import { Typography, Divider } from "antd";
import VendorDetails from "./VendorDetails";
import ExclusiveDetails from "./ExclusiveDetails";
import { InfoCircleFilled } from "@ant-design/icons";

const { Title } = Typography;
export default function InternalDetails({
  fields,
  vendorFields,
  showVendorDetails,
  setVendorDetailsButton,
  exclusiveFields,
  showExclusiveDetails,
  setExclusiveDetailsButton,
  form,
  formData,
  files,
  categoryId,
  allCategoryData,
}) {
  const renderVendorDetailsInfoBox = () => {
    return (
      <div
        style={{
          padding: 14,
          display: "flex",
          justifyContent: "center",
          background: "#F1F7FF",
          borderRadius: 4,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 14,
          }}
        >
          <InfoCircleFilled style={{ fontSize: "14px", color: "#4989E9" }} />
        </div>
        <div style={{ fontSize: 14 }}>
          All the internal details are confidential. The platform does not allow
          any user to share this with buyers.
        </div>
      </div>
    );
  };

  return (
    <div id="internal">
      <Title level={5} style={{ fontSize: 16, marginBottom: "2vh" }}>
        3. Internal Details
      </Title>
      <div
        style={{
          border: "1px dashed #cdcfce",
          padding: 20,
          borderRadius: 4,
        }}
      >
        {renderVendorDetailsInfoBox()}

        <FieldRenderer
          fields={fields}
          form={form}
          formData={formData}
          files={files}
          categoryId={categoryId}
          allCategoryData={allCategoryData}
        />

        <VendorDetails
          fields={vendorFields}
          setVendorDetailsButton={setVendorDetailsButton}
          showVendorDetails={showVendorDetails}
        />
        <ExclusiveDetails
          fields={exclusiveFields}
          setExclusiveDetailsButton={setExclusiveDetailsButton}
          showExclusiveDetails={showExclusiveDetails}
          categoryId={categoryId}
          allCategoryData={allCategoryData}
        />
      </div>
      <Divider />
    </div>
  );
}
